import { Directive, Input, HostListener, Renderer, ElementRef } from '@angular/core';

@Directive({
  selector: '[hoverClass]'
})
export class HoverClassDirective {
  @Input()
  hoverClass: string;

  constructor(
    public elementRef: ElementRef,
    private renderer: Renderer
  ) { }

  @HostListener('mouseover') mouseover() {
    this.renderer.setElementClass(this.elementRef.nativeElement, this.hoverClass, true);
  }

}



// WEBPACK FOOTER //
// /Users/Dan/Documents/PoC/angular-giaa/src/app/hover-class.directive.ts